import { get } from './';

const byCategoryNameAndSearch = (query) => get('/product_catalog/byCategoryNameAndSearch', query);

const searchApi = {
  byCategoryNameAndSearch,
};

export default searchApi;
